import error from '~/store/plugin/error'

export default defineNuxtPlugin(() => {
  usePinia().use(error)
})
